import { _Blog_liquid } from "../../@types/shopify";

const initBlogCard = ($el: HTMLElement, $refs: Record<string, HTMLElement>, blogHandle: string) => {
  const random_id = utils.shortUUID();

  const blog =
    _blogs[blogHandle] || utils.JSONParse<_Blog_liquid>(document.querySelector(`[data-blog-data="${blogHandle}"]`)?.innerHTML);

  const state = window.Alpine.reactive({
    random_id,
    hydrated: true,
    ...(blog ?? {}),
    url: blog?.url ?? `/blogs/${blog?.handle}`,
  });

  const getDynamicValue = (content: string) => {
    return utils.getBracketInputDynamicValue(content, state);
  };

  const getDynamicValueWithFallbacks = (content: string) => {
    return content.split(",")?.reduce((acc, item) => {
      acc ||= utils.getBracketInputDynamicValue(item.trim(), state);
      return acc;
    }, "");
  };

  const getDynamicText = (content: string) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  };

  const getContentLabels = (key: string) => {
    const labels = key.split(".").reduce<any>((acc, selector) => {
      if (!selector || acc === undefined || acc === null) return acc || "";

      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);

    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  };

  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels,
  };
};

const fallbackHydrationQueue = new Set<HTMLElement>();

const hydrateBlogCardContent = ($el: HTMLElement) => {
  const card_handle = $el.getAttribute(`data-card-handle`);
  const blog_handle = $el.getAttribute(`data-blog-handle`);
  const blog_id = $el.getAttribute(`data-blog-id`);
  const classes = utils.JSONParse<string[]>($el.getAttribute(`data-card-classes`) ?? "[]");

  const node = document.querySelector(`[data-blog-card='${card_handle}']`)?.cloneNode(true) as HTMLElement;

  if (!node) {
    fallbackHydrationQueue.add($el);
    return;
  }

  node?.removeAttribute(`data-blog-card`);
  node?.setAttribute("data-blog-handle", blog_handle);
  node?.setAttribute("data-blog-id", blog_id);
  node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
    el.remove();
  });

  node.classList.add(...classes);
  $el.parentNode?.replaceChild(node, $el);
};

document.addEventListener("modalsLoaded", () => {
  fallbackHydrationQueue.forEach((el) => {
    hydrateBlogCardContent(el);
  });
  fallbackHydrationQueue.clear();
});

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        hydrateBlogCardContent(entry.target);
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: "300px 300px 300px 300px" }
);

const hydrateBlogCard = ($el: HTMLElement) => {
  if ($el.hasAttribute("data-intersected")) {
    hydrateBlogCardContent($el);
    return;
  }

  observer.observe($el);
};

export type InitBlogCard = typeof initBlogCard;
export type HydrateBlogCard = typeof hydrateBlogCard;

window._sections["initBlogCard"] = initBlogCard;
window._sections["hydrateBlogCard"] = hydrateBlogCard;
